import React, {useContext, useEffect, useState} from "react"
import moment from "moment"

import {List, ListItemOrderHistoryDetails, DetailInfoRow} from "~/components/"
import {ShoppingCartContext} from "../../context/ShoppingCartContext"
import {useTranslation} from "react-i18next"

const OrderDetailView = props => {
  const {t} = useTranslation()
  const orderId = props.match.params.order_id

  const [shoppingCart, setShoppingCart] = useState(null)
  const {archivedShoppingCarts} = useContext(ShoppingCartContext)

  useEffect(() => {
    const shoppingCart = archivedShoppingCarts.filter(
      s => s.id === parseInt(orderId)
    )
    if (shoppingCart[0]) {
      setShoppingCart(shoppingCart[0])
    }
  }, [archivedShoppingCarts, orderId])

  if (!shoppingCart) {
    return null
  }

  const orderDate = moment(shoppingCart.ordered_at).format("DD.MM.YYYY")

  return (
    <div className="sh-detail-view">
      <div className="header">
        <div className="title">{t("orders.title", {orderId: orderId})}</div>
      </div>
      <div>
        <DetailInfoRow label={t("orders.orderDate")} value={orderDate} />
        <DetailInfoRow
          label={t("orders.orderedBy")}
          value={shoppingCart.user.email}
        />
        <DetailInfoRow
          label={t("orders.orderedBy")}
          value={t("orders.orderDetails", {
            user: shoppingCart.user.email,
            orderDate: orderDate
          })}
        />

        <DetailInfoRow label={t("orders.note")} value={shoppingCart.comment} />
        <DetailInfoRow label={t("orders.articleList")}>
          <List
            items={shoppingCart.product_in_carts}
            itemRenderer={ListItemOrderHistoryDetails}
          />
        </DetailInfoRow>
      </div>
    </div>
  )
}

export default OrderDetailView



// WEBPACK FOOTER //
// ./src/views/detail/OrderDetailView.js